var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Flex } from "../..";
export var CardHeaderContainer = function (_a) {
    var _b = _a.isExpandable, isExpandable = _b === void 0 ? false : _b, _c = _a.isExpanded, isExpanded = _c === void 0 ? false : _c, children = _a.children, lss = _a.lss;
    return (React.createElement(Flex, { lss: __assign({ flexWrap: 'wrap', justifyContent: 'space-between', p: 'md', width: '100%', alignItems: 'center', borderTopLeftRadius: 'inherit', borderTopRightRadius: 'inherit', borderBottomLeftRadius: isExpandable && !isExpanded ? 'inherit' : 0, borderBottomRightRadius: isExpandable && !isExpanded ? 'inherit' : 0, borderBottom: 'regular', bg: 'gray100' }, lss) }, children));
};
//# sourceMappingURL=CardHeaderContainer.js.map